import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { putErrorNotification } from '../../../../../../../utils/saga';
import { boost, boostSuccess, boostError } from '../actions';

function* boostSaga(action: ReturnType<typeof boost>): SagaIterator {
  const {
    payload: { deviationId, duration, tags },
  } = action;

  const response = yield call(requestPuppy, {
    method: 'post',
    url: '/corebadge/boost',
    data: {
      deviation_id: deviationId,
      duration,
      tags,
    },
  });

  if (!response || !response.success || isApiError(response)) {
    const errorMessage =
      response?.error?.message || 'Failed to boost deviation';
    yield putErrorNotification(response?.error?.message);
    yield put(boostError(errorMessage));
  } else {
    yield put(boostSuccess({ deviationId: String(deviationId) }));
  }
}

export default function* boostActionSaga() {
  yield takeEvery(boost, boostSaga);
}
